export const DateUtil = {
    /**
     * 时间格式化
     * @param date
     * @param format
     * @returns {*}
     */
    format (date, format) {
        if (!date) {
            return null;
        }
        format = format || 'yyyy-MM-dd';
        if (date instanceof Date) {
            // 无需转换
        } else {
            switch (typeof date) {
                case 'string':
                    if (date.indexOf('T')>-1) {
                        date = new Date(date);
                    } else if(/^\d+$/.test(date)) {
                        date = new Date(Number(date));
                    } else{
                        date = new Date(date.replace(/-/g, '/'));
                    }
                    break;
                case 'number':
                    date = new Date(date);
                    break;
                default:
                    date = new Date();
                    break;
            }
        }
        if (!(date instanceof Date)) return;
        // 计算年的后两位
        let shortYear = date.getYear();
        shortYear = shortYear < 2000 ? shortYear + 1900 : shortYear;
        let yy = shortYear.toString().substr(2, 2);
        // 时间格式
        // console.log(date.getMonth() + 1)
        let dict = {
            'yy': yy,
            'yyyy': date.getFullYear(),
            'M': date.getMonth() + 1,
            'd': date.getDate(),
            'H': date.getHours(),
            'm': date.getMinutes(),
            's': date.getSeconds(),
            'MM': ('' + (date.getMonth() + 101)).substr(1),
            'dd': ('' + (date.getDate() + 100)).substr(1),
            'HH': ('' + (date.getHours() + 100)).substr(1),
            'mm': ('' + (date.getMinutes() + 100)).substr(1),
            'ss': ('' + (date.getSeconds() + 100)).substr(1)
        };
        return format.replace(/(y+|MM?|dd?|HH?|ss?|mm?)/g, function () {
            return dict[arguments[0]];
        });
    },
    // parseTime(time, pattern) {
    //   if (arguments.length === 0 || !time) {
    //     return null
    //   }
    //   const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
    //   let date
    //   if (typeof time === 'object') {
    //     date = time
    //   } else {
    //     if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
    //       time = parseInt(time)
    //     } else if (typeof time === 'string') {
    //       time = time.replace(new RegExp(/-/gm), '/');
    //     }
    //     if ((typeof time === 'number') && (time.toString().length === 10)) {
    //       time = time * 1000
    //     }
    //     date = new Date(time)
    //   }
    //   const formatObj = {
    //     y: date.getFullYear(),
    //     m: date.getMonth() + 1,
    //     d: date.getDate(),
    //     h: date.getHours(),
    //     i: date.getMinutes(),
    //     s: date.getSeconds(),
    //     a: date.getDay()
    //   }
    //   const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    //     let value = formatObj[key]
    //     // Note: getDay() returns 0 on Sunday
    //     if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    //     if (result.length > 0 && value < 10) {
    //       value = '0' + value
    //     }
    //     return value || 0
    //   })
    //   return time_str
    // },
    /**
     * 获取当前日期
     * @param format
     * @returns {*}
     */
    getCurrentDate (format) {
        return this.format(new Date(), format);
    },
    /**
     * 获取当前日期
     * @returns {*}
     */
    getCurrentDateTime () {
        return this.format(new Date(), 'yyyy-MM-dd HH:mm:ss');
    },
    /**
     * 获取日期中的年份
     * @param date
     * @returns {*}
     */
    getYearMonth (date, month) {
      if (!month) {
        return this.format(date, 'yyyy-MM');
      } else {
        return this.format(date + '-' + month, 'yyyy-MM');
      }
    },
    /**
     * 获取日期中的年份
     * @param date
     * @returns {*}
     */
    getYear (date) {
        if (date) {
            if (!date) {
                let d = new Date();
                return d.getFullYear();
            } else if (date instanceof Date) {
                // 无需转换
            } else {
                switch (typeof date) {
                    case 'string':
                        date = new Date(date.replace(/-/g, '/'));
                        break;
                    case 'number':
                        date = new Date(date);
                        break;
                    default:
                        break;
                }
            }
            if (!(date instanceof Date)) return '';
            return date.getFullYear();
        }
    },
    /**
     * 获取日期中的月
     * @param date
     * @returns {*}
     */
    getMonth (date) {
        var month = "";
        // month = date.getMonth() + 1; //getMonth()得到的月份是0-11

        if (!date) {
            let d = new Date();
            month = d.getMonth() + 1;
        } else if (date instanceof Date) {
            // 无需转换
        } else {
            switch (typeof date) {
                case 'string':
                    date = new Date(date.replace(/-/g, '/'));
                    break;
                case 'number':
                    date = new Date(date);
                    break;
                default:
                    break;
            }
        }
        if (!(date instanceof Date)) return '';
        month = date.getMonth() + 1;
        if (month < 10) {
            month = "0" + month;
        }
        return month;
    },
    /**
     * 获取日期中的日
     * @param date
     * @returns {*}
     */
    getDay (date) {
        if (!date) {
            let d = new Date();
            return d.getDate();
        } else if (date instanceof Date) {
            // 无需转换
        } else {
            switch (typeof date) {
                case 'string':
                    date = new Date(date.replace(/-/g, '/'));
                    break;
                case 'number':
                    date = new Date(date);
                    break;
                default:
                    break;
            }
        }
        if (!(date instanceof Date)) return '';
        return date.getDate();
    },
    /**
     * 获取指定日期所在月的天数
     * @param date
     * @returns {*}
     */
    getDaysOfMonth(date) {
        if (!date) {
            let d = new Date();
            return d.getDate();
        } else if (date instanceof Date) {
            // 无需转换
        } else {
            switch (typeof date) {
                case 'string':
                    date = new Date(date.replace(/-/g, '/'));
                    break;
                case 'number':
                    date = new Date(date);
                    break;
                default:
                    break;
            }
        }
        if (!(date instanceof Date)) return '';
        let thisDate = new Date(date.getFullYear(), date.getMonth() + 1, 0); // 当天数为0 js自动处理为上一月的最后一天
        return thisDate.getDate();
    },
    /**
     * 当月第一天
     * @returns {Date}
     */
    getFirstDayOfCurrentMonth () {
        let date = new Date();
        date.setDate(1);
        return date;
    },
  /**
   *根据指定日期获取当前月第一天
   *  */
  getFirstDayOfBydate (date) {
    date.setDate(1);
    return date;
  },
  /**
   *根据指定日期获取当前月最后一天
   *  */
  getLastDayOfBydate (date) {
    let currentMonth = date.getMonth();
    let nextMonth = ++currentMonth;
    let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
    let oneDay = 1000 * 60 * 60 * 24;
    return new Date(nextMonthFirstDay - oneDay);
  },
    /**
     * 当月最后一天
     * @returns {Date}
     */
    getLastDayOfCurrentMonth () {
        let date = new Date();
        let currentMonth = date.getMonth();
        let nextMonth = ++currentMonth;
        let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
        let oneDay = 1000 * 60 * 60 * 24;
        return new Date(nextMonthFirstDay - oneDay);
    },
    /**
     * 上月第一天
     */
    getFirstDayOfLastMonth () {
        let nowdays = new Date();
        let year = nowdays.getFullYear();
        let month = nowdays.getMonth();
        if (month === 0) {
            month = 12;
            year = year - 1;
        }
        if (month < 10) {
            month = '0' + month;
        }
        let myDate = new Date(year, month, 1);
        return myDate;
    },
    /**
     * 上月最后一天
     * @returns {Date}
     */
    getLastDayOfLastMonth () {
        let nowdays = new Date();
        let year = nowdays.getFullYear();
        let month = nowdays.getMonth();
        let myDate = new Date(year, month, 0);
        return myDate;
    },
    /**
     * 获取1个月后的日期
     * @param date
     * @returns {string}
     */
    getNextMonth (date) {
        return this.dateAddMonth(date, 1);
    },
    /**
     * 获取1年后的日期
     * @param date
     * @returns {string}
     */
    getNextYear (date) {
        return this.dateAddMonth(date, 12);
    },
    /**
     * m个月后的日期
     * @param d
     * @param m
     * @returns {string}
     */
    dateAddMonth (d, m) {
        // if (d instanceof Date) {
        //     // 无需转换
        // } else {
        //     switch (typeof d) {
        //         case 'string':
        //             d = new Date(d.replace(/-/g, '/'));
        //             break;
        //         case 'number':
        //             d = new Date(d);
        //             break;
        //         default:
        //             return null;
        //     }
        // }
        // d.setMonth(d.getMonth() + m);
        // return this.format(d);
        d = this.format(d);
        if (d && d.indexOf('-') > -1) {
            let ds = d.split('-');
            let _d = ds[2] - 0;
            let nextM = new Date(ds[0], ds[1] - 1 + m + 1, 0);
            let max = nextM.getDate();
            d = new Date(ds[0], ds[1] - 1 + m, _d > max ? max : _d);
            return d.toLocaleDateString().match(/\d+/g).join('-');
        }
        return null;
    },
    /**
     * m天后的日期
     * @param d
     * @param m
     * @returns {string}
     */
    dateAddDay (d, m) {
        if (d instanceof Date) {
            // 无需转换
        } else {
            switch (typeof d) {
                case 'string':
                    d = new Date(d.replace(/-/g, '/'));
                    break;
                case 'number':
                    d = new Date(d);
                    break;
                default:
                    return null;
            }
        }
        if (!(d instanceof Date)) return;
        d.setDate(d.getDate() + m);
        return this.format(d);
    },
    /**
     * 比较日期
     * @param startDate
     * @param endDate
     * @returns {number}
     */
    dateCompare (startDate, endDate) {
        let d1 = new Date(startDate.replace(/-/g, '/')).getTime();
        let d2 = new Date(endDate.replace(/-/g, '/')).getTime();
        if (d1 === d2) {
            return 0;
        } else if (d1 > d2) {
            return 1;
        } else {
            return -1;
        }
    },
    /**
     *  计算两个日期间的相差天数
     * @param d1
     * @param d2
     * @returns {number}
     */
    dateDiff (d1, d2) {
        if (!d1 || !d2) { return null; }
        let day = 24 * 60 * 60 * 1000;
        d1 = this.format(d1);
        d2 = this.format(d2);
        try {
            let dateArr = d1.split('-');
            let checkDate = new Date();
            checkDate.setFullYear(dateArr[0], dateArr[1] - 1, dateArr[2]);
            let checkTime = checkDate.getTime();
            let dateArr2 = d2.split('-');
            let checkDate2 = new Date();
            checkDate2.setFullYear(dateArr2[0], dateArr2[1] - 1, dateArr2[2]);
            let checkTime2 = checkDate2.getTime();
            let diff = (checkTime - checkTime2) / day;
            return Math.ceil(diff);
        } catch (e) {
            return null;
        }
    },
    /**
     *  计算两个日期间的月差
     * @param d1
     * @param d2
     * @param precise 精确到天
     * @returns {number}
     */
    monthDiff (d1, d2, precise) {
        if (!d1 || !d2) return null;
        precise = precise || true;
        let year1 = this.getYear(d1);
        let month1 = this.getMonth(d1);
        let year2 = this.getYear(d2);
        let month2 = this.getMonth(d2);
        let offset = 0;
        if (d1 > d2 && precise) {
            let day1 = this.getDay(d1);
            let day2 = this.getDay(d2);
            if (day1 > day2) {
                offset = 1;
            }
        }
        return year1 * 12 + month1 - (year2 * 12 + month2) + offset;
    },
    /**
     * 获取前几天
     * @param gap
     * @returns {Date}
     */
    beforeDate (gap) {
        let beforeDate = new Date();
        beforeDate.setDate(beforeDate.getDate() - gap);
        return beforeDate;
    },
    /**
     * 添加日期范围
     * @param params
     * @param dateRange
     * @param 开始结束日期字段后缀
     * @returns {*}
     */
    addDateRange(params, dateRange, propName) {
      let search = params;
      search.params = typeof (search.params) === 'object' && search.params !== null && !Array.isArray(search.params) ? search.params : {};
      dateRange = Array.isArray(dateRange) ? dateRange : [];
      if (typeof (propName) === 'undefined') {
        search.params['beginTime'] = dateRange[0];
        search.params['endTime'] = dateRange[1];
      } else {
        search.params['begin' + propName] = dateRange[0];
        search.params['end' + propName] = dateRange[1];
      }
      return search;
    },
    /**
     * 获取月份字典
     * @param
     * @returns {*}
     */
    getDictMonth() {
      let array = [];
      for(let index=1; index <=12; index++) {
        let item = {};
        item.dictLabel = index + '月';
        item.dictValue = '' + index;
        array.push(item);
      }
      return array;
    },
    /**
     * 获取季度字典
     * @param
     * @returns {*}
     */
    getDictQuarter() {
      let array = [];
      for(let index=1; index <=4; index++) {
        let item = {};
        let label = ''
        switch (index) {
          case 1:
            label = '一';
            break;
          case 2:
            label = '二';
            break;
          case 3:
            label = '三';
            break;
          case 4:
            label = '四';
            break;
        }
        item.dictLabel = label + '季度';
        item.dictValue = '' + index;
        array.push(item);
      }
      return array;
    },
    dateFormat(longTypeDate){
        var dateTypeDate = "";
        var date = new Date();
        date.setTime(longTypeDate);
        dateTypeDate += date.getFullYear(); //年
        dateTypeDate += "-" + this.getMonth(date); //月
        dateTypeDate += "-" + this.getDay(date); //日
        return dateTypeDate;
    },
  /**
   * 根据出生日期获取当前周岁年龄
   * @param strBirthday
   * @returns {*}
   */
    getCurrentAge(strBirthday){
      // 将出生日期的字符串通过"-"分割成数组
      const strBirthdayArr = strBirthday.split("-")
      // 拿到出生日期的年
      const birthYear = strBirthdayArr[0]
      // 拿到出生日期的月
      const birthMonth = strBirthdayArr[1]
      // 拿到出生日期的日
      const birthDay = strBirthdayArr[2]
      // 创建一个时间对象
      const d = new Date()
      // 拿到当前时间的年
      const nowYear = d.getFullYear()
      // 拿到当前时间的月
      const nowMonth = d.getMonth() + 1
      // 拿到当前时间的日
      const nowDay = d.getDate()
      // 如果出生日期的年等于当前时间的年
      if(nowYear === birthYear) return 0 // 返回周岁年龄 0,并终止函数执行
      // 如果如果出生日期的年不等于于当前时间的年,则拿到年之差
      const ageDiff = nowYear - birthYear ; // 年之差
      // 如果年之差是个负数,则表示用户输入的出生日期错误,晚于今天,返回 -1,并终止函数执行
      if(ageDiff < 0) return -1 // 返回错误 -1,并终止函数执行
      // 如果年之差是个正整数,但出生日期的月与当前时间的月不相等
      if(nowMonth !== birthMonth){
        // 拿到出生日期的日与当前时间的月之差
        const monthDiff = nowMonth - birthMonth; // 月之差
        // 如果月之差是个负数,则年之差 - 1后得到周岁年龄,否则直接得到周岁年龄
        return monthDiff < 0 ? ageDiff - 1 : ageDiff  // 返回周岁年龄,并终止函数执行
      }
      // 如果出生日期的月与当前时间的月相等,则拿到出生日期的日与当前时间的日之差
      const dayDiff = nowDay - birthDay;
      // 如果日之差是个负数,则年之差 - 1得到周岁年龄,否则直接得到周岁年龄
      return dayDiff < 0 ? ageDiff - 1 : ageDiff // 返回周岁年龄,并终止函数执行
    },
  /**
   * 获取当前招聘年度
   * @returns {string}
   */
  getRecruitmentYear () {
    var recruitmentYear = null;
    const currentDay = this.format(new Date(), 'yyyy-MM-dd');
    const currentYear = Number(currentDay.substring(0, 4));
    const currentNextYear = currentYear + 1;
    const currentMonth = currentDay.substring(5, 7);
    // 匹配招聘年度规则
    switch (currentMonth) {
    //   case '08':
    //     recruitmentYear = currentNextYear;
    //     break;
      case '09':
        recruitmentYear = currentNextYear;
        break;
      case '10':
        recruitmentYear = currentNextYear;
        break;
      case '11':
        recruitmentYear = currentNextYear;
        break;
      case '12':
        recruitmentYear = currentNextYear;
        break;
      default:
        recruitmentYear = currentYear;
        break;
    }
    recruitmentYear = recruitmentYear.toString();
    return recruitmentYear;
  }
};
